import React, { lazy, Suspense, useEffect, useRef } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import MenuService from "services/MenuService";

export const AppViews = () => {
	let intervalId = useRef(null);

	const populateMenu = async () => {
		try {
			if (JwtAuthService.isLogged()) {
				await MenuService.populateMenuData();
			}
		} catch (e) {}

		//intervalId.current = setInterval(async () => {
		//	if (JwtAuthService.isLogged()) {
		//		await MenuService.populateMenuData();
		//	}
		//}, 30000);
	};

	useEffect(() => {
		populateMenu();

		return () => {
			clearInterval(intervalId.current);
		};
	}, []);

	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard`}
					component={lazy(() => import(`./dashboard`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/relatorios`}
					component={lazy(() => import(`./relatorios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dados-conta`}
					component={lazy(() => import(`./dados-conta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-usuarios`}
					component={lazy(() => import(`./lista-usuarios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/usuario/:id`}
					component={lazy(() => import(`./usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/usuario`}
					component={lazy(() => import(`./usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-grupos-usuario`}
					component={lazy(() => import(`./lista-grupos-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-usuario/:id`}
					component={lazy(() => import(`./grupo-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-usuario`}
					component={lazy(() => import(`./grupo-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-clientes`}
					component={lazy(() => import(`./lista-clientes`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/cliente/:id`}
					component={lazy(() => import(`./cliente`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/cliente`}
					component={lazy(() => import(`./cliente`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-centros-distribuicao`}
					component={lazy(() =>
						import(`./lista-centros-distribuicao`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/centro-distribuicao/:id`}
					component={lazy(() => import(`./centro-distribuicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/centro-distribuicao`}
					component={lazy(() => import(`./centro-distribuicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-carregadores`}
					component={lazy(() => import(`./lista-carregadores`))}
				/>
				<Route
					exact
					path={`${APP_PREFIX_PATH}/carregador-admin/novo`}
					component={lazy(() => import(`./carregador-admin`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/carregador-admin/:tenantSchema/:id`}
					component={lazy(() => import(`./carregador-admin`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-carregadores-admin`}
					component={lazy(() =>
						import(`./lista-carregadores-admin`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-middleware-releases`}
					component={lazy(() =>
						import(`./lista-middleware-releases`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/carregador/:id`}
					component={lazy(() => import(`./carregador`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/carregador`}
					component={lazy(() => import(`./carregador`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-tipos-bateria`}
					component={lazy(() => import(`./lista-tipos-bateria`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/tipo-bateria/:id`}
					component={lazy(() => import(`./tipo-bateria`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/tipo-bateria`}
					component={lazy(() => import(`./tipo-bateria`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-modelos-bateria`}
					component={lazy(() => import(`./lista-modelos-bateria`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-modelo-bateria-serie-override`}
					component={lazy(() =>
						import(`./lista-modelo-bateria-serie-override`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/modelo-bateria/:id`}
					component={lazy(() => import(`./modelo-bateria`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/modelo-bateria`}
					component={lazy(() => import(`./modelo-bateria`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard-teste-bateria`}
					component={lazy(() => import(`./dashboard-teste-bateria`))}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}/dashboard-operacao-lite`}
					to={`${APP_PREFIX_PATH}/dashboard-teste-bateria`}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}/dashboard-simples`}
					to={`${APP_PREFIX_PATH}/dashboard-teste-bateria`}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/escolha-carregador`}
					component={lazy(() => import(`./escolha-carregador`))}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}/novo-teste`}
					to={`${APP_PREFIX_PATH}/dashboard-teste-bateria`}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/logs`}
					component={lazy(() => import(`./logs`))}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${APP_PREFIX_PATH}/dashboard`}
				/>
			</Switch>
		</Suspense>
	);
};

export default React.memo(AppViews);
